// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._4FHkjaaox{}._2dz05Smix{color:#cb2e62;font-weight:bold}._3VraHcUMx{height:24px;width:24px;padding:12px}._75PkmhRix{margin-left:1px;padding:12px}._3yKZrlq7x{margin-left:0;padding-left:0}._2mLNIVEZx{margin-right:8px;display:flex}._5N2hOvNFx{margin-right:16px}._6uQzAgiMx{margin-right:1px}._4pHpNO5nx{width:260px;display:flex}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"link": "_4FHkjaaox " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unanchor"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"app-center": "_2dz05Smix",
	"appCenter": "_2dz05Smix",
	"icon": "_3VraHcUMx",
	"padded-icon": "_75PkmhRix _3VraHcUMx",
	"paddedIcon": "_75PkmhRix _3VraHcUMx",
	"mobile-padded-icon": "_3yKZrlq7x _75PkmhRix _3VraHcUMx",
	"mobilePaddedIcon": "_3yKZrlq7x _75PkmhRix _3VraHcUMx",
	"logo-default": "_2mLNIVEZx",
	"logoDefault": "_2mLNIVEZx",
	"logo-expanded": "_5N2hOvNFx",
	"logoExpanded": "_5N2hOvNFx",
	"logo-collapsed": "_6uQzAgiMx",
	"logoCollapsed": "_6uQzAgiMx",
	"logo-fixed-width": "_4pHpNO5nx",
	"logoFixedWidth": "_4pHpNO5nx"
};
module.exports = exports;
